<template>
  <div :class="classes">
    <pt-page-title title="账户额度管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
    </pt-page-title>
    <el-button type="primary" @click="toEnterAmount">录入额度</el-button>
    <p :class="$style['all-balance-text']">总可用额度：<span :class="$style['balance-color']" v-if="balanceTotal || balanceTotal === 0">{{balanceTotal}}元</span> <i class="el-icon-loading" v-else></i></p>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
    <p :class="$style['balance-text']" v-if="balanceList">
      <span v-for="(item,index) in balanceList" :key="index">{{item.departmentName}}：<span :class="$style['balance-money']">{{item.quota}}元</span></span>
    </p>
    <pt-balance-manage-table :tableLabels="balanceManageTableLabels" :paramsData="paramsData" ref="table">
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
              <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
            </template>
        </el-table-column>
    </pt-balance-manage-table>
    <enter-amount-dialog :dialogVisible="showDialog" @close="closeDialog" :departmentList="departmentList" :editAmount="editAmount" :isEdit="isEdit">
    </enter-amount-dialog>
  </div>
</template>

<script>
// 组件class前缀
import enterAmountDialog from './enter-amount-dialog'
import ptBalanceManageTable from './pt-balance-manage-table/withData'
import { balanceManageTableLabels, filterLabels } from './balance-manage'

import {
  emptyObject
} from '@/utils/lifebankUtils'
import formMixins from 'mixins/form'
const prefixCls = 'pt-balance-manage'

export default {
  name: 'pt-balance-manage',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    table () {
      return this.$refs.table
    }
  },
  props: {
    departmentList: {
      type: Array,
      default: () => []
    },
    balanceTotal: {
      type: [Number, String]
    },
    balanceList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ptBalanceManageTable,
    enterAmountDialog
  },
  watch: {
    departmentList: {
      handler (val) {
        if (val) {
          this.filterLabels.forEach(item => {
            if (item.value === 'departmentId') {
              item.options = val.map(e => {
                return {
                  label: e.label,
                  value: JSON.parse(e.value).id
                }
              })
            }
          })
        }
      },
      deep: true
    },
    'params.departmentId': {
      handler (val) {
        if (val) {
          this.filterLabels.forEach(item => {
            if (item.value === 'departmentId') {
              item.options.forEach(e => {
                if (e.value === val) {
                  this.departmentName = e.label
                }
              })
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      filterLabels: filterLabels,
      balanceManageTableLabels: balanceManageTableLabels,
      searchKey: '',
      params: {},
      paramsData: {},
      showDialog: false,
      departmentName: '',
      changeDepartmentName: '',
      editAmount: {},
      isEdit: false
    }
  },
  methods: {
    toEdit (val) {
      this.isEdit = true
      this.editAmount = val
      this.showDialog = true
    },
    closeDialog (val) {
      if (val) {
        this.$emit('enterAmountSuc')
        this.$refs.table.getBalanceList(0)
      }
      this.showDialog = false
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter(false)
    },
    Filter (isFromRouter) {
      // this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (key === 'operateTime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (this.params[key] === null || this.params[key] === '') {
          this.$delete(this.params, key)
        }
      }
      this.paramsData = this.params
      this.changeDepartmentName = this.departmentName
      this.$emit('enterAmountSuc')
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'searchKey')
    },
    toDetail (val) {
      this.$router.push('./balance-detail/' + val.id)
    },
    toEnterAmount () {
      this.isEdit = false
      this.showDialog = true
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .all-balance-text {
    font-size: 22px;
    color: #606266;
    margin:.3rem 0;
  }

  .balance-color {
    color: #edbe81
  }
  .balance-text {
    text-align: right;
    font-size: 20px;
    color: #606266;
    margin-top: .3rem;
    padding-bottom: .2rem;
    border-bottom: 1px solid #EDBE81;
  }
  .balance-money {
    color: #EDBE81;
    margin-right: .3rem;
  }
</style>
